import { createAsyncThunk } from '@reduxjs/toolkit';
import { agentApi } from '~/apis/agent';
import { IParamAccountAgent, IParamDetailAgent, IPayloadDeleteAgent, IPayloadNote, IPayloadUpdateAgent } from '~/data/account';
import { IAddAgent } from '~/pages/agents/addAgent/addAgent.interface';
import {
  CREATE_AGENT,
  CREATE_AGENT_NOTE,
  DELETE_AGENT,
  GET_AGENT_CODE,
  GET_AGENT_NOTE,
  GET_DETAIL_AGENT,
  GET_LIST_AGENT,
  SEARCH_LIST_AGENT,
  UPDATE_AGENT,
} from '~/utils/actionType';

export const createAgent = createAsyncThunk(CREATE_AGENT, async (payload: IAddAgent, { rejectWithValue }) => {
  try {
    const res = await agentApi.createAgent(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getListAgent = createAsyncThunk(GET_LIST_AGENT, async (params: IParamAccountAgent, { rejectWithValue }) => {
  try {
    const res = await agentApi.getListAgent(params);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteAgent = createAsyncThunk(DELETE_AGENT, async (payload: IPayloadDeleteAgent, { rejectWithValue }) => {
  try {
    const res = await agentApi.deleteAccountAgent(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailAgent = createAsyncThunk(GET_DETAIL_AGENT, async (param: IParamDetailAgent, { rejectWithValue }) => {
  try {
    const res = await agentApi.getDetailAgent(param);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateAgent = createAsyncThunk(UPDATE_AGENT, async (payload: IPayloadUpdateAgent, { rejectWithValue }) => {
  try {
    const res = await agentApi.updateAccountAgent(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const searchAgents = createAsyncThunk(SEARCH_LIST_AGENT, async (params: IParamAccountAgent, { rejectWithValue }) => {
  try {
    const res = await agentApi.getListAgent(params);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getAgentNote = createAsyncThunk(GET_AGENT_NOTE, async (_, { rejectWithValue }) => {
  try {
    const res = await agentApi.getAgentNote();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createAgentNote = createAsyncThunk(CREATE_AGENT_NOTE, async (params: IPayloadNote, { rejectWithValue }) => {
  try {
    const res = await agentApi.createAgentNote(params);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getAgentCode = createAsyncThunk(GET_AGENT_CODE, async (_, { rejectWithValue }) => {
  try {
    const res = await agentApi.getAgentCode();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
